module.exports = __webpack_public_path__ + "static/media/chooseTeacher.e78e98ee.jpg";